import React from 'react'
import moment from 'moment'
import _ from 'lodash'

let monthOptions = (() => {
  let format = 'YYYY-MM'
  let startMonth = '2018-09'
  let currentMonth = moment().startOf('month')
  let count = Math.floor(
    moment.duration(currentMonth.diff(moment(startMonth, format))).asMonths()
  )

  return _.times(count, t =>
    currentMonth.clone().subtract(t, 'months').format(format)
  )
})()

let pretty = str => {
  let [year, month] = str.split('-')

  return moment()
    .year(year)
    .month(_.parseInt(month) - 1) // remember months are 0-indexed
    .format('YYYY - MMMM')
}

let MonthSelect = ({ month, setMonth }) => {
  return (
    <select
      className="form-control"
      value={month}
      onChange={e => setMonth(e.target.value)}
    >
      {monthOptions.map(m => (
        <option value={m} key={m}>
          {pretty(m)}
        </option>
      ))}
    </select>
  )
}

export default MonthSelect
